export const formDefaultValues = {
  name: '',
  body: '',
}
